import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=1fbd9d1e&scoped=true"
import script from "./Media.vue?vue&type=script&lang=ts"
export * from "./Media.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbd9d1e",
  null
  
)

export default component.exports